import { useState } from "react";

import { trpc } from "@blis/trpc/react";

import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { Section } from "../components/Section";
import { FieldSetsTable } from "../components/tubes/FieldSetsTable";
import { FieldsTable } from "../components/tubes/FieldsTable";
import { TubesTable } from "../components/tubes/TubesTable";
import { useTabSearch } from "../hooks";

export function TubesPage() {
  const [showArchived, setShowArchived] = useState(false);
  const { data } = trpc.admin.tube.list.useQuery({
    includeArchived: showArchived,
  });

  const tabsProps = useTabSearch("tubes");

  return (
    <>
      <Section.Title>Containers</Section.Title>
      <Tabs {...tabsProps} className="flex-1 flex flex-col">
        <TabsList className="mb-4 w-full justify-start">
          <Tab id="tubes">Containers</Tab>
          <Tab id="field-sets">Field sets</Tab>
          <Tab id="custom-fields">Custom fields</Tab>
        </TabsList>
        <TabPanel id="tubes" className="flex flex-col flex-1">
          <TubesTable
            tubes={data}
            showArchived={showArchived}
            onShowArchivedChange={setShowArchived}
          />
        </TabPanel>
        <TabPanel id="field-sets" className="flex flex-col flex-1">
          <FieldSetsTable />
        </TabPanel>
        <TabPanel id="custom-fields" className="flex flex-col flex-1">
          <FieldsTable />
        </TabPanel>
      </Tabs>
    </>
  );
}
